import React, { useEffect } from "react";

const Content = () => {
  useEffect(() => {
    const initializeCarousel = () => {
      if (window.$ && window.$.fn.owlCarousel) {
        const $carousel = window.$("#partners-carousel");

        if ($carousel.length && $carousel.data("owlCarousel")) {
          $carousel.trigger("destroy.owl.carousel");
          $carousel.removeClass("owl-carousel owl-loaded");
          $carousel.find(".owl-stage-outer").children().unwrap();
        }

        if ($carousel.length) {
          $carousel.owlCarousel({
            items: 4,
            margin: 30,
            loop: true,
            nav: true,
            slideBy: 1,
            dots: true,
            center: false,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            autoheight: false,
            navText: [
              '<i class="icofont-thin-left"></i>',
              '<i class="icofont-thin-right"></i>',
            ],
            responsive: {
              0: { items: 2, margin: 15 },
              480: { items: 2, margin: 20 },
              768: { items: 3, margin: 25 },
              992: { items: 4, margin: 30 },
              1200: { items: 5, margin: 30 },
            },
          });
        }
      }
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initializeCarousel);
    } else {
      setTimeout(initializeCarousel, 100);
    }
    const timer = setTimeout(initializeCarousel, 500);

    return () => {
      clearTimeout(timer);
      if (window.$ && window.$("#partners-carousel").length) {
        const $carousel = window.$("#partners-carousel");
        if ($carousel.data("owlCarousel")) {
          $carousel.trigger("destroy.owl.carousel");
        }
      }
    };
  }, []);

  return (
    <>
      <main id="body-content">
        {/* <section className="bg-white wide-tb-100">
                    <div className="container pos-rel">
                        <div className="row">
                            <div className="col-md-12 col-lg-6">
                                <p><img src="images/years_img.png" alt="" className="mb-5" /></p>
                                <p>La Société LOG 2 TRANS est une filiale de <b className="text-secondary">KIMORHAR INVESTMENT GROUP</b>, spécialisée en : </p>
                                <div className="img-icon mt-4 d-flex align-items-center">
                                    <img src="images/team/team-1.jpg" />
                                    <h3>
                                        John Morise
                                        <span>Founder & CEO</span>
                                    </h3>
                                </div>
                            </div>

                            <div className="w-100 spacer-50 d-none d-md-block d-lg-none d-sm-none"></div>
                            <div className="col-md-12 col-lg-6">

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="icon-box-6">
                                            <i className="icofont-box"></i>
                                            <h3 className="h3-xs txt-blue">Packaging and Storage</h3>
                                            <p>Praesent pellentesque diam vitae nibh aliquam faucibus.</p>
                                            <a href="#" className="btn-arrow bg-primary"><i className="icofont-swoosh-right"></i></a>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="icon-box-6">
                                            <i className="icofont-safety"></i>
                                            <h3 className="h3-xs txt-blue">Safety & Quality</h3>
                                            <p>Praesent pellentesque diam vitae nibh aliquam faucibus.</p>
                                            <a href="#" className="btn-arrow bg-primary"><i className="icofont-swoosh-right"></i></a>
                                        </div>
                                    </div>

                                    <div className="w-100 spacer-50 d-none d-lg-none d-md-block d-lg-block d-sm-none"></div>

                                    <div className="col-12 col-md-6">
                                        <div className="icon-box-6">
                                            <i className="icofont-tree-alt"></i>
                                            <h3 className="h3-xs txt-blue">Care for Environment</h3>
                                            <p>Praesent pellentesque diam vitae nibh aliquam faucibus.</p>
                                            <a href="#" className="btn-arrow bg-primary"><i className="icofont-swoosh-right"></i></a>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="icon-box-6">
                                            <i className="icofont-delivery-time"></i>
                                            <h3 className="h3-xs txt-blue">Delivery On Time</h3>
                                            <p>Praesent pellentesque diam vitae nibh aliquam faucibus.</p>
                                            <a href="#" className="btn-arrow bg-primary"><i className="icofont-swoosh-right"></i></a>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </section> */}

        <section className="bg-light-gray wide-tb-100 bg-wave">
          <div className="container">
            <div className="row">
              <div
                className="col-sm-12 wow fadeInDown text-center"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <h1 className="heading-main">
                  <span>A Propos de Nous</span>
                  Bienvenue à Log2Trans
                </h1>
              </div>
            </div>
            <div className="row align-items-start">
              <div className="col-lg-5 col-md-12 mb-5 mb-lg-0">
                <div className="about-images-wrapper">
                  <div className="about-img-main">
                    <img
                      src="images/IMG_1766.png"
                      alt="Log2Trans"
                      className="img-fluid"
                    />
                  </div>
                  <div className="about-img-secondary">
                    <img
                      src="images/IMG_1759.JPG"
                      alt="Notre équipe"
                      className="img-fluid"
                    />
                  </div>
                  <div className="about-stats-badge">
                    <span className="stats-number">110 +</span>
                    <span className="stats-label">Clients Satisfaits</span>
                  </div>
                </div>
              </div>

              <div className="col-lg-7 col-md-12">
                <div className="about-content-wrapper">
                  <p className="about-description">
                    Filiale de{" "}
                    <strong className="text-secondary">
                      KIMORHAR INVESTMENT GROUP
                    </strong>
                    , spécialisée dans les domaines suivants :
                  </p>

                  <div className="about-features">
                    <div className="about-feature-item">
                      <div className="feature-icon">
                        <i className="icofont-law-document"></i>
                      </div>
                      <div className="feature-content">
                        <h5>Commission en Douane</h5>
                        <p>
                          Gestion complète de vos formalités douanières avec
                          expertise et rapidité.
                        </p>
                      </div>
                    </div>

                    <div className="about-feature-item">
                      <div className="feature-icon">
                        <i className="icofont-oil-truck"></i>
                      </div>
                      <div className="feature-content">
                        <h5>Logistique industrielle et pétrolière</h5>
                        <p>
                          Solutions logistiques adaptées au secteur industriel
                          et pétrolier.
                        </p>
                      </div>
                    </div>

                    <div className="about-feature-item">
                      <div className="feature-icon">
                        <i className="icofont-truck-loaded"></i>
                      </div>
                      <div className="feature-content">
                        <h5>Transport et Manutention</h5>
                        <p>
                          Flotte moderne et équipes qualifiées pour vos
                          marchandises.
                        </p>
                      </div>
                    </div>

                    <div className="about-feature-item">
                      <div className="feature-icon">
                        <i className="icofont-globe"></i>
                      </div>
                      <div className="feature-content">
                        <h5>Intermédiation dans le commerce international</h5>
                        <p>
                          Accompagnement dans vos échanges commerciaux à
                          l'international.
                        </p>
                      </div>
                    </div>

                    <div className="about-feature-item">
                      <div className="feature-icon">
                        <i className="icofont-handshake-deal"></i>
                      </div>
                      <div className="feature-content">
                        <h5>Conseil en achat/vente à l'international</h5>
                        <p>
                          Expertise pour optimiser vos transactions commerciales
                          internationales.
                        </p>
                      </div>
                    </div>

                    <div className="about-feature-item">
                      <div className="feature-icon">
                        <i className="icofont-clip-board"></i>
                      </div>
                      <div className="feature-content">
                        <h5>Conseil en procédures douanières</h5>
                        <p>
                          Accompagnement personnalisé pour toutes vos démarches
                          douanières.
                        </p>
                      </div>
                    </div>
                  </div>

                  <p className="mt-4 mb-0">
                    <i className="icofont-check-circled text-primary mr-2"></i>
                    <strong>Notre force</strong> est de pouvoir s'associer, si
                    besoin, aux compétences des sociétés partenaires
                    spécialisées.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white wide-tb-100 pb-5">
          <div className="container pos-rel">
            <div className="row">
              <div
                className="col-sm-12 wow fadeInDown text-center"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <h1 className="heading-main">
                  <span>Vos avantages</span>
                  Pourquoi nous choisir ?
                </h1>
              </div>

              <div
                className="col-12 col-lg-4 wow fadeInUp"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <div className="icon-box-2 mb-4">
                  <div className="media">
                    <div className="service-icon">
                      <i className="icofont-clock-time"></i>
                    </div>
                    <div className="service-inner-content media-body">
                      <h4 className="h4-md">Gain de temps</h4>
                      <p>
                        Nous optimisons vos processus logistiques pour vous
                        faire gagner un temps précieux dans vos opérations.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="icon-box-2 mb-4">
                  <div className="media">
                    <div className="service-icon">
                      <i className="icofont-money"></i>
                    </div>
                    <div className="service-inner-content media-body">
                      <h4 className="h4-md">Coûts maîtrisés</h4>
                      <p>
                        Des tarifs compétitifs et transparents pour optimiser
                        votre budget logistique sans compromis sur la qualité.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="icon-box-2">
                  <div className="media">
                    <div className="service-icon">
                      <i className="icofont-location-pin"></i>
                    </div>
                    <div className="service-inner-content media-body">
                      <h4 className="h4-md">Tracking en temps réel</h4>
                      <p>
                        Suivez vos marchandises à chaque étape grâce à notre
                        système de suivi GPS en temps réel.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-4 d-none d-lg-block">
                <img src="images/img-2.jpg" alt="" className="w-100" />
              </div>

              <div
                className="col-12 col-lg-4 wow fadeInUp"
                data-wow-duration="0"
                data-wow-delay="0.2s"
              >
                <div className="icon-box-2 mb-4">
                  <div className="media">
                    <div className="service-icon">
                      <i className="icofont-handshake-deal"></i>
                    </div>
                    <div className="service-inner-content media-body">
                      <h4 className="h4-md">Relationnel privilégié</h4>
                      <p>
                        Une équipe dédiée à votre écoute pour un service
                        personnalisé et des solutions adaptées à vos besoins.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="icon-box-2 mb-4">
                  <div className="media">
                    <div className="service-icon">
                      <i className="icofont-truck-loaded"></i>
                    </div>
                    <div className="service-inner-content media-body">
                      <h4 className="h4-md">Transport sécurisé</h4>
                      <p>
                        Une flotte moderne et entretenue pour garantir la
                        sécurité et l'intégrité de vos marchandises.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="icon-box-2">
                  <div className="media">
                    <div className="service-icon">
                      <i className="icofont-badge"></i>
                    </div>
                    <div className="service-inner-content media-body">
                      <h4 className="h4-md">Garantie qualité</h4>
                      <p>
                        Un service certifié et des procédures rigoureuses pour
                        assurer votre satisfaction à chaque étape.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="wide-tb-100 bg-fixed bg-1 pos-rel mb-spacer-md">
          <div className="bg-overlay blue opacity-80"></div>
          <div className="container">
            <div className="row">
              <div
                className="col counter-style-1 col-6 col-lg-3 col-sm-6 wow fadeInRight"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <p>
                  <i className="icofont-google-map"></i>
                </p>
                <span className="counter">15</span>
                <div>Sites</div>
              </div>
              <div
                className="col counter-style-1 col-6 col-lg-3 col-sm-6 wow fadeInRight"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <p>
                  <i className="icofont-globe"></i>
                </p>
                <span className="counter">110</span>
                <span>+</span>
                <div>Clients</div>
              </div>
              <div
                className="col counter-style-1 col-6 col-lg-3 col-sm-6 wow fadeInRight"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <p>
                  <i className="icofont-vehicle-delivery-van"></i>
                </p>
                <span className="counter">240</span>
                <span>+</span>
                <div>Véhicles</div>
              </div>
              <div
                className="col counter-style-1 col-6 col-lg-3 col-sm-6 wow fadeInRight"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <p>
                  <i className="icofont-umbrella-alt"></i>
                </p>
                <span className="counter">2340</span>
                <div>Tonnes Transportées</div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-light-gray wide-tb-100">
          <div className="container">
            <div className="row">
              <div
                className="col-sm-12 wow fadeInDown text-center"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <h1 className="heading-main">
                  <span>Notre Organisation</span>
                  Ce qui nous rend spécial
                </h1>
              </div>
            </div>

            <div className="row pt-4 org-cards-row">
              <div
                className="col-12 col-md-6 col-lg-3 mb-4 wow fadeInUp org-card-col org-card-col-1"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <div className="org-card">
                  <div className="org-card-icon">
                    <i className="icofont-network-tower"></i>
                  </div>
                  <h4>Nos relations</h4>
                  <ul className="org-card-list">
                    <li>
                      <i className="icofont-check"></i>Notre réseau de
                      correspondants
                    </li>
                    <li>
                      <i className="icofont-check"></i>Notre parfaite maîtrise
                      du cadre juridique et institutionnel en matière de
                      Douane, Transport, Logistique et Transit
                    </li>
                  </ul>
                </div>
              </div>

              <div
                className="col-12 col-md-6 col-lg-3 mb-4 wow fadeInUp org-card-col org-card-col-2"
                data-wow-duration="0"
                data-wow-delay="0.1s"
              >
                <div className="org-card">
                  <div className="org-card-icon">
                    <i className="icofont-building-alt"></i>
                  </div>
                  <h4>Notre environnement</h4>
                  <ul className="org-card-list">
                    <li>
                      <i className="icofont-check"></i>Cadre de travail
                      confortable
                    </li>
                    <li>
                      <i className="icofont-check"></i>Des équipements
                      technologiques de pointe
                    </li>
                  </ul>
                </div>
              </div>

              <div
                className="col-12 col-md-6 col-lg-3 mb-4 wow fadeInUp org-card-col org-card-col-3"
                data-wow-duration="0"
                data-wow-delay="0.2s"
              >
                <div className="org-card">
                  <div className="org-card-icon">
                    <i className="icofont-users-social"></i>
                  </div>
                  <h4>Notre équipe</h4>
                  <ul className="org-card-list">
                    <li>
                      <i className="icofont-check"></i>Des professionnels
                      pétris d'expérience
                    </li>
                    <li>
                      <i className="icofont-check"></i>Personnel jeune,
                      qualifié et dynamique
                    </li>
                    <li>
                      <i className="icofont-check"></i>Compétences
                      pluridisciplinaires (Management, Droit, Gestion,
                      Informatique, Commerce international...)
                    </li>
                  </ul>
                </div>
              </div>

              <div
                className="col-12 col-md-6 col-lg-3 mb-4 wow fadeInUp org-card-col org-card-col-4"
                data-wow-duration="0"
                data-wow-delay="0.3s"
              >
                <div className="org-card">
                  <div className="org-card-icon">
                    <i className="icofont-computer"></i>
                  </div>
                  <h4>Système d'information</h4>
                  <ul className="org-card-list">
                    <li>
                      <i className="icofont-check"></i>Connexion Internet pour
                      la transmission des informations
                    </li>
                    <li>
                      <i className="icofont-check"></i>Plateforme dédiée aux
                      opérations
                    </li>
                    <li>
                      <i className="icofont-check"></i>Bases de données
                      informatiques modernes
                    </li>
                    <li>
                      <i className="icofont-check"></i>Site internet interactif
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-sky-blue wide-tb-100">
          <div className="container pos-rel">
            <div className="row">
              <div className="img-business-man">
                <img src="images/IMG_1704.png" alt="" />
              </div>
              <div
                className="col-sm-12 wow fadeInDown"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <h1 className="heading-main">
                  <span>Ce qui nous rend spécial</span>
                  Vous gagnerez
                </h1>
              </div>
              <div className="col-md-6 ml-auto">
                <div className="row">
                  <div
                    className="col-12 wow fadeInUp"
                    data-wow-duration="0"
                    data-wow-delay="0s"
                  >
                    <div className="icon-box-3 mb-5 bg-sky-blue">
                      <div className="media">
                        <div className="service-icon mr-5">
                          <i className="icofont-clock-time"></i>
                        </div>
                        <div className="service-inner-content media-body">
                          <h4 className="h4-md">En temps</h4>
                          <p>
                            Vous réduirez le temps consacré au suivi de
                            procédures de dédouanement de vos marchandises.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 wow fadeInUp"
                    data-wow-duration="0"
                    data-wow-delay="0.2s"
                  >
                    <div className="icon-box-3 mb-5 bg-sky-blue">
                      <div className="media">
                        <div className="service-icon mr-5">
                          <i className="icofont-shield"></i>
                        </div>
                        <div className="service-inner-content media-body">
                          <h4 className="h4-md">En tranquillité</h4>
                          <p>
                            Vous serez désormais exempts des tracasseries
                            douanières et de la lourdeur des procédures
                            administratives dans les différentes administrations
                            y relatives.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 wow fadeInUp"
                    data-wow-duration="0"
                    data-wow-delay="0.4s"
                  >
                    <div className="icon-box-3 bg-sky-blue">
                      <div className="media">
                        <div className="service-icon mr-5">
                          <i className="icofont-badge"></i>
                        </div>
                        <div className="service-inner-content media-body">
                          <h4 className="h4-md">En fiabilité</h4>
                          <p>
                            Le grand apport des Nouvelles Technologies de
                            l'Information et de la Communication dans notre mode
                            de fonctionnement garantira la rapidité et la
                            fiabilité de vos opérations. La mise à jour de notre
                            base de données des textes et règlements nationaux
                            et internationaux garantira l'actualisation de notre
                            expertise sur le plan juridique.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="wide-tb-100 bg-white pos-rel partners-section-modern">
          <div className="container">
            <div className="row">
              <div
                className="col-sm-12 wow fadeInDown text-center mb-4"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <h1 className="heading-main">
                  <span>Nos Partenaires</span>
                  Des collaborations de confiance
                </h1>
                <p className="mt-3 text-muted">
                  Nous travaillons avec les meilleurs partenaires pour vous
                  offrir des services de qualité supérieure
                </p>
              </div>

              <div
                className="col-sm-12 wow fadeInUp"
                data-wow-duration="0"
                data-wow-delay="0.2s"
              >
                <div className="partners-carousel-wrapper">
                  <div
                    className="owl-carousel owl-theme"
                    id="partners-carousel"
                  >
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/africacontainershipping.jpg"
                          alt="Africa Container Shipping"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/asecna.png"
                          alt="ASECNA"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/btc.png"
                          alt="BTC"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/gulfcam.png"
                          alt="Gulfcam"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/moleculesgas.png"
                          alt="Molecules Gas"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/novaplast.png"
                          alt="Novaplast"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/parlym.png"
                          alt="Parlym"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/neptune.png"
                          alt="Neptune"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/psl.jpg"
                          alt="PSL"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/tradex.png"
                          alt="Tradex"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/scdp.png"
                          alt="SCDP"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/ttc.png"
                          alt="TTC"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/zte.png"
                          alt="ZTE"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/hydrac.jpg"
                          alt="Hydrac"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="wide-tb-80 bg-scroll bg-img-6 pos-rel callout-style-1">
                    <div className="bg-overlay blue opacity-60"></div>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-4 col-md-12 mb-0 wow slideInUp" data-wow-duration="0" data-wow-delay="0.1s">
                                <h4 className="h4-xl">Interested in working with Logzee?</h4>
                            </div>
                            <div className="col wow slideInUp" data-wow-duration="0" data-wow-delay="0.2s">
                                <div className="center-text">
                                    We don’t just manage suppliers, we micro-manage them. We have a consultative, personalized approach
                                </div>
                            </div>
                            <div className="col-sm-auto wow slideInUp" data-wow-duration="0" data-wow-delay="0.3s">
                                <a href="#" className="btn btn-theme bg-white bordered">Get In Touch <i className="icofont-rounded-right"></i></a>
                            </div>
                        </div>
                    </div>
                </section> */}
      </main>
    </>
  );
};
export default Content;
